import { createServerFn } from "@tanstack/react-start";

/**
 * Public read of the `early_access_form_visible` site setting.
 * Defaults to visible when the row is missing.
 */
export const getEarlyAccessVisible = createServerFn({ method: "GET" }).handler(
  async (): Promise<boolean> => {
    const { cached } = await import("@/lib/server-cache.server");
    return cached("early-access", 120_000, async () => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data } = await supabaseAdmin
      .from("site_settings")
      .select("value")
      .eq("key", "early_access_form_visible")
      .maybeSingle();
    if (!data) return true;
    return data.value === true || data.value === "true";
    });
  },
);
